import { MixedItem, RBAssetType } from 'store/railsBuilder/reducer.types';

import { DetailsRequestUrlType } from 'screens/Detail/types';

import { VodEditorial } from '../types';
import getRBAssetChannelId from './getRBAssetChannelId';

function getRBVodEditorialDetailsParams(
    vodEditorial: VodEditorial,
): MixedItem['detailsPageParams'] {
    const {
        id,
        contentRef,
        type,
        seriesRef,
        technicals,
        SeasonNumber,
        episodeNumber,
    } = vodEditorial;
    const channelId = getRBAssetChannelId(vodEditorial);

    if (seriesRef) {
        return {
            filterType: DetailsRequestUrlType.PROGRAM,
            id,
            channelId,
            seriesId: seriesRef,
            programId: technicals?.[0]?.ProgramId,
            season: SeasonNumber,
            episode: episodeNumber,
        };
    }

    const contentId = contentRef || id;

    if (type === RBAssetType.EDITORIAL) {
        return {
            filterType: DetailsRequestUrlType.VOD,
            id,
            editorialId: contentId,
            programId: technicals?.[0].ProgramId,
            channelId,
        };
    }

    if (contentId) {
        return {
            filterType: DetailsRequestUrlType.VOD,
            id,
            channelId,
            contentRef: contentId,
        };
    }

    return {
        filterType: DetailsRequestUrlType.PROGRAM,
        id,
        channelId,
    };
}

export default getRBVodEditorialDetailsParams;
